import React from 'react';
import { Link } from 'gatsby-plugin-react-i18next';
// import { scroller } from 'react-scroll';
import PropTypes from 'prop-types';

import useLanguage from '../../../../hooks/useLanguage';

import Arrow from '../../../../svg/arr_right_top.svg';

const MainNavigation = ({ showSubMenu, dataMainNav, open, closeMenu }) => {
  const langToggle = useLanguage;

  // function scrollFooter() {
  //   scroller.scrollTo('footer', {
  //     duration: 500,
  //     delay: 0,
  //     smooth: 'easeInOutQuart',
  //   });
  // }

  return (
    <ul className="navigation">
      {dataMainNav.map((item, index) => {
        const counter = ++index;
        if (item.marker === 'link') {
          return (
            <li
              className={open ? 'navigation-item is-open' : 'navigation-item'}
              key={index}
            >
              <Link to={item.link} className="navigation-item__link">
                <span className="navigation-link__count">
                  {counter <= 9 ? '0' + counter + '.' : counter + '.'}
                </span>
                <span className="navigation-item__link-title">
                  {langToggle(item.title_ua, item.title_ru)}
                </span>
                <span className="navigation-link__icon">
                  <Arrow className="navigation-link__arrow" />
                </span>
              </Link>
            </li>
          );
        } else if (item.marker === 'services') {
          return (
            <li
              className={open ? 'navigation-item is-open' : 'navigation-item'}
              key={index}
            >
              <button className="navigation-item__link" onClick={showSubMenu}>
                <span className="navigation-link__count">
                  {counter <= 9 ? '0' + counter + '.' : counter + '.'}
                </span>
                <span className="navigation-item__link-title">
                  {langToggle(item.title_ua, item.title_ru)}
                </span>
                <span className="navigation-link__icon">
                  <Arrow className="navigation-link__arrow" />
                </span>
              </button>
            </li>
          );
        } else {
          return (
            <li
              className={open ? 'navigation-item is-open' : 'navigation-item'}
              key={index}
            >
              <a
                href="#footer"
                className="navigation-item__link"
                data-scroll-to
                onClick={closeMenu}
              >
                <span className="navigation-link__count">
                  {counter <= 9 ? '0' + counter + '.' : counter + '.'}
                </span>
                <span className="navigation-item__link-title">
                  {langToggle(item.title_ua, item.title_ru)}
                </span>
                <span className="navigation-link__icon">
                  <Arrow className="navigation-link__arrow" />
                </span>
              </a>
            </li>
          );
        }
      })}
    </ul>
  );
};

MainNavigation.propTypes = {
  showSubMenu: PropTypes.func,
  dataMainNav: PropTypes.array,
  open: PropTypes.bool,
};

export default MainNavigation;
